import comp from "./AddQuestionLoader";
export default comp;
